/** LiveArt script */
(function (LiveArt) {
  /**
    Customize button logic
    Update designer link with selected variant before redirect
    May need customization according to your theme
    Liveart product id is expected to be specified in data-liveart-product-id button attribute
    Selected variant can be provided in the following ways:
      - data-selected-variant-id attribute
      - variant_selector - selector of the master variants input
      - otherwise attempt to get variant from URL query
  */
  LiveArt.redirectToDesigner = function (event, variant_selector) {
    if (event.preventDefault) event.preventDefault();
    // 1. get data from target attributes
    var designerUrl =
        event.currentTarget.attributes.href.value ||
        event.currentTarget.dataset.liveartDesignerUrl;
    var liveartProductId = event.currentTarget.dataset.liveartProductId;
    var liveartTemplateId = event.currentTarget.dataset.liveartTemplateId;
    var liveartDesignId = event.currentTarget.dataset.liveartDesignId;
    var variant = event.currentTarget.dataset.selectedVariantId;
    // 2. Fallback to get variant from selector
    if (!variant) {
      var variantEl = document.querySelector(variant_selector + "");
      if (variantEl && variantEl.tagName === "SELECT")
        variant = variantEl.selectedOptions[0].value || variant;
      else if (variantEl && variantEl.tagName === "INPUT") {
        variant = variantEl.value || variant;
      } else {
        variant = new URLSearchParams(window.location.search).get("variant");
      }
    }
    // 3. Form designer url, fallback to default page
    var url = new URL(designerUrl, window.location.href);
    if (!designerUrl) {
      url.pathname = "/pages/liveart-designer";
    }
    // 3.1 Form designer parameters
    var searchParams = new URLSearchParams();
    if (liveartProductId) searchParams.set("product_id", liveartProductId);
    if (liveartTemplateId) searchParams.set("template_id", liveartTemplateId);
    if (liveartDesignId) searchParams.set("design_id", liveartDesignId);
    if (variant) searchParams.set("ext_variant_id", variant + "");
    url.search = searchParams.toString();
    // 4. Redirect to designer page
    window.location.href = url.toString();
  };
})((window.LiveArt = window.LiveArt || {}));
